import React from "react";
import ViaFind from "components/ViaFind";
import RadioButton from "components/ui/RadioButton";
import t from "lib/i18n";

const TicketOptions = ({ setFieldValue, via, ticketType }) => (
  <div className="otrl-jp__tickets__options">
    <ViaFind onChange={setFieldValue("via")} via={via} />
    <div
      className="otrl-jp__tickets__journey-type"
      role="radiogroup"
      aria-label={t("tickets.radio.aria")}
    >
      <RadioButton
        label="Single"
        name="ticketType"
        onChange={setFieldValue("ticketType")}
        selected={ticketType}
        value="single"
      />
      <RadioButton
        name="ticketType"
        label="Return"
        onChange={setFieldValue("ticketType")}
        selected={ticketType}
        value="return"
      />
      <RadioButton
        name="ticketType"
        label="Open return"
        onChange={setFieldValue("ticketType")}
        selected={ticketType}
        value="open"
      />
    </div>
  </div>
);

export default React.memo(TicketOptions);
